<div class="header">
    <mat-icon svgIcon="shield-check"></mat-icon>
    <h1>
        {{ 'research.portal.irus.uk.cookies.snackbar.title' | translate }}
    </h1>
</div>
<div class="cookie-content">
    <p class="message">{{ data.message }}</p>
    <div class="button-wrapper">
        <a mat-flat-button href="https://irus.jisc.ac.uk/about/" target="_blank" color="primary">
            {{ 'research.portal.irus.uk.cookies.snackbar.learn.more.button' | translate }}
        </a>
        <button mat-raised-button (click)="onAccept()">
            {{ 'research.portal.irus.uk.cookies.snackbar.accept.button' | translate }}
        </button>
    </div>
</div>
